import { IMapBBoxBounds } from '../../types/mapBounds';

export function mapBBoxBoundsToInfrastructureCachingBBox({ bounds }: IMapBBoxBounds): string {
  const [[latMin, lngMin], [latMax, lngMax]] = bounds;

  return `${lngMin},${latMin}~${lngMax},${latMax}`;
}
